import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import { roundInfoStore } from '@pascal/pascal-core/shared/core/store';

import { roundTimeStore } from '../../../store';
import { globalTranslationKeys } from '../../../enums';
import { RoundStepInfo } from '../../web/roundStepInfo';
import { MobileRoundStepInfo } from '../../mobile/mobileRoundStepInfo';

export const RoundStepInfoSection = observer(({ isMobile }) => {
  const t = useTranslation();
  const { time } = roundTimeStore;
  const { duration } = roundInfoStore;

  const step = useMemo(() => {
    if (time > duration * 0.3) {
      return t(globalTranslationKeys.PLACE_YOUR_BETS);
    }
    if (time <= duration * 0.3 && time >= duration * 0.1) {
      return t(globalTranslationKeys.BETS_ARE_CLOSING);
    }
    if (time === 0 || time < duration * 0.1) {
      return t(globalTranslationKeys.BETS_ARE_CLOSED);
    }

    return null;
  }, [duration, t, time]);

  return isMobile ? (
    <MobileRoundStepInfo className='n-b' step={step} />
  ) : (
    <RoundStepInfo step={step} />
  );
});
